import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { Link, useHistory } from "react-router-dom";
import ImgPlaceHolder from "../../constant/imgPlaceholder";
import { onlyNumber } from "../../constant/utils";
import { DoctorDetailform } from "../../constant/validation";
import { doctorAction, submitAction } from "../../redux/action";
import { ROUTE } from "../../route/Route";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import WaitScreen from "../LodingScreen/WaitScreen";
import SeoAdd from "../Seo/SeoAdd";
import { useTranslation } from "react-i18next";
import Recaptcha from "../ReCaptcha";

const initialValue = {
  Name: "",
  Email: "",
  Mobile: "",
  Message: "",
  UtmSource: "",
  UtmMedium: "",
  UtmCampaign: "",
  Checkbox: false,
  GRecaptcha:""
};

function DoctorDetails() {
  const { t } = useTranslation();
  const { slug } = useParams<any>();
  const dispatch = useDispatch();
  const history = useHistory();
  const [imgUri, setImgUri] = useState<string>("");
  const [videoUri, setVideoUri] = useState<string>("");
  const [doctor, setDoctor] = useState<any>({});
  const doctorData = useSelector((state: any) => (state.doctor.selected ? state.doctor.selected : {}));

  useEffect(() => {
    window?.scrollTo(0, 0);
    dispatch(doctorAction.getDoctorDetailAction({ DoctorCode: slug }));
    return () => {};
  }, []);

  useEffect(() => {
    if (doctorData) {
      setImgUri(doctorData?.DoctorAWSBaseUrl);
      setVideoUri(doctorData?.DoctorAWSBaseUrl);
      setDoctor(doctorData?.DoctorDetails);
    }
    return () => {};
  }, [doctorData]);

  const handleSubmit = (values: any) => {
    let value: any = { ...values };
    value.DoctorId = doctor?.Id;
    value.SourceUrl = window.location.href;
    const urlParams = new URLSearchParams(window.location.search);
    value.UtmSource = urlParams.get("utm_source");
    value.UtmMedium = urlParams.get("utm_medium");
    value.UtmCampaign = urlParams.get("utm_campaign");
    dispatch(submitAction.submitQueryAction(value, history));
  };

  return (
    <>
      <SeoAdd slug={ROUTE.DOCTORDETAILS} />
      {doctorData && Object.keys(doctorData)?.length < 1 && <WaitScreen />}
      <BreadCrumb page={doctor?.Name} data={{ slug: "", path: "" }} />
      {doctor && Object.keys(doctor)?.length > 0 && (
        <>
          <section className="about-section">
            <div className="container" id="section2">
              <div className="row">
                <div className="col-md-3">
                  <div className="infobox_wrapper">
                    <div>
                      <img
                        src={doctor?.ProfileImage && doctor?.ProfileImage}
                        // onError={(e: any) =>
                        //   ImgPlaceHolder(e, "/assets/img/dr.jpg")
                        // }
                        className="scale round_img"
                        alt=""
                      />
                    </div>
                    <div className="mt-3">
                      <h4 className="doct_title mb-2">{doctor?.Name}</h4>
                      <div className="doct_post mb-2">{doctor?.Designation}</div>
                      <div className="doct_lab mb-2">{doctor?.DepartmentName}</div>
                    </div>
                  </div>
                  {doctor?.OtherVideos &&
                    doctor?.OtherVideos?.length > 0 &&
                    doctor?.OtherVideos?.map((item: any, i: any) => (
                      <div className="infobox_wrapper my-5">
                        <ReactPlayer
                          className="scale"
                          style={{ border: "1px solid #707070" }}
                          controls
                          url={`${videoUri}${doctor?.item}`}
                        />
                      </div>
                    ))}
                  <section className="bg-white px-3 px-md-0 my-5">
                    <div className="container small_form">
                      <div className="row">
                        <div className="col-12">
                          <div className="headingmains text-center mt-4">
                            <h4 className="right aos-init">{t("enquiry")}</h4>
                          </div>
                        </div>
                      </div>
                      <Formik
                        initialValues={initialValue}
                        enableReinitialize={true}
                        validationSchema={DoctorDetailform}
                        onSubmit={(val: any) => {
                          handleSubmit(val);
                        }}
                        render={({
                          values,
                          handleChange,
                          errors,
                          touched,
                          handleBlur,
                          handleSubmit,
                          setFieldValue,
                        }:any) => {
                          return (
                            <form onSubmit={handleSubmit}>
                              <div className="row justify-content-center">
                                <div className="col-12 col-md-10 col-lg-9 col-xl-9">
                                  <div className="row align-items-center mt-4">
                                    <input
                                      type="text"
                                      name="Name"
                                      className="form-control"
                                      placeholder={t("name")}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values?.Name}
                                    />
                                    {touched?.Name && errors?.Name && (
                                      <span className="error_message">{t(errors?.Name)}</span>
                                    )}
                                  </div>
                                  <div className="row align-items-center mt-4">
                                    <input
                                      type="text"
                                      name="Mobile"
                                      className="form-control"
                                      placeholder={t("mobile_number")}
                                      onKeyPress={onlyNumber}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values?.Mobile}
                                    />
                                    {touched?.Mobile && errors?.Mobile && (
                                      <span className="error_message">{t(errors?.Mobile)}</span>
                                    )}
                                  </div>
                                  <div className="row align-items-center mt-4">
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder={t("email")}
                                      name="Email"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values?.Email}
                                    />
                                    {touched?.Email && errors?.Email && (
                                      <span className="error_message">{t(errors?.Email)}</span>
                                    )}
                                  </div>
                                  <div className="row align-items-center mt-4">
                                    <textarea
                                      className="form-control"
                                      placeholder={t("message")}
                                      name="Message"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values?.Message}
                                    ></textarea>
                                    {touched?.Message && errors?.Message && (
                                      <span className="error_message">{t(errors?.Message)}</span>
                                    )}
                                  </div>
                                  <div className="row align-items-center mt-4 w-full">
                                    <div className="d-flex for-check-style">
                                      <input
                                        type="checkbox"
                                        name="Checkbox"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        id="checkbox_id"
                                      />
                                      <label className="mx-2" htmlFor="checkbox_id">
                                        By clicking you accept to the{" "}
                                        <a className="text-info" href="https://oncquestlabs.com/terms-condition">
                                          terms and conditions
                                        </a>{" "}
                                        and the{" "}
                                        <a className="text-info" href="https://oncquestlabs.com/privacy-policy">
                                          Privacy Policy.
                                        </a>
                                      </label>
                                    </div>
                                    <div>
                                      {touched?.Checkbox && errors?.Checkbox && (
                                        <span className="error_message">{errors?.Checkbox}</span>
                                      )}
                                    </div>
                                  </div>
                                  <div className="row my-2">
                                    <Recaptcha
                                      touch={touched?.GRecaptcha}
                                      error={errors?.GRecaptcha}
                                      onChange={(token: any) => setFieldValue("GRecaptcha", token)}
                                      onExpired={()=> setFieldValue("GRecaptcha", "")}
                                    />
                                  </div>
                                  <div className="row my-2">
                                    <button type="submit" className="book--hexagon active ml-0">
                                      <span>
                                        {t("submit_btn")}
                                        <i className="fa fa-long-arrow-right ml-20" aria-hidden="true"></i>
                                      </span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </form>
                          );
                        }}
                      />
                    </div>
                  </section>
                </div>
                <div className="col-md-9">
                  <div className="h-services doc_info_box">
                    <div className="infobox_wrapper">
                      {doctor?.Details && (
                        <>
                          <div className="box">
                            <h5 className="doc_title">
                              {"About "}
                              {doctor?.Name}
                            </h5>
                            <div
                              className="doc_content"
                              dangerouslySetInnerHTML={{
                                __html: doctor?.Details,
                              }}
                            ></div>
                          </div>
                          <hr className="hr" />
                        </>
                      )}
                      {doctor?.Qualification && (
                        <>
                          <div className="box">
                            <h5 className="doc_title">{t("qualifications")}</h5>
                            <div className="infobox_list">
                              <ul>
                                {doctor?.Qualification &&
                                  doctor?.Qualification?.split(",")?.map((item: any, i: any) => (
                                    <li key={i} className="doc_content">
                                      {item}
                                    </li>
                                  ))}
                              </ul>
                            </div>
                          </div>
                          <hr className="hr" />
                        </>
                      )}
                      {doctor?.Expertise && (
                        <>
                          <div className="box">
                            <h5 className="doc_title">{t("expertise")}</h5>
                            <div className="infobox_list">
                              <ul>
                                {doctor?.Expertise &&
                                  doctor?.Expertise?.split(",")?.map((item: any, i: any) => (
                                    <li className="doc_content" key={i}>
                                      {item}
                                    </li>
                                  ))}
                              </ul>
                            </div>
                          </div>
                          <hr className="hr" />
                        </>
                      )}
                      {doctor?.AreaInterest && (
                        <>
                          <div className="box">
                            <h5 className="doc_title">{t("area_of_interest")}</h5>
                            <div className="infobox_list">
                              <ul>
                                <li className="doc_content">{doctor?.AreaInterest}</li>
                              </ul>
                            </div>
                          </div>
                          <hr className="hr" />
                        </>
                      )}
                      {doctor?.ResearchPublication && (
                        <>
                          <div className="box">
                            <h5 className="doc_title">{t("research_and_publication")} </h5>
                            <div className="infobox_list">
                              <div
                                className="doc_content"
                                dangerouslySetInnerHTML={{
                                  __html: doctor?.ResearchPublication,
                                }}
                              ></div>
                            </div>
                          </div>
                          <hr className="hr" />
                        </>
                      )}
                      {doctor?.Awards && doctor?.Awards?.length > 0 && (
                        <>
                          <div className="box">
                            <h5 className="doc_title">{t("honours_awards")}</h5>
                            <div className="infobox_list">
                              <ul>
                                {doctor &&
                                  doctor?.Awards?.length > 0 &&
                                  doctor?.Awards?.map((item: any, index: any) => (
                                    <li className="doc_content" key={index}>
                                      {item?.title}
                                    </li>
                                  ))}
                              </ul>
                            </div>
                          </div>
                        </>
                      )}
                      {doctor?.MainVideoYoutubeLink ? (
                        <>
                          <hr className="hr" />
                          <div className="box">
                            <ReactPlayer
                              className="scale"
                              style={{ border: "1px solid #707070" }}
                              controls
                              url={doctor?.MainVideoYoutubeLink}
                            />
                          </div>
                        </>
                      ) : (
                        doctor?.MainVideo && (
                          <>
                            <hr className="hr" />
                            <div className="box">
                              <ReactPlayer
                                className="scale"
                                style={{ border: "1px solid #707070" }}
                                controls
                                url={`${videoUri}${doctor?.MainVideo}`}
                              />
                            </div>
                          </>
                        )
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
}

export default DoctorDetails;
